namespace RedBullMOBILE360.LoanWhitelist {
    export interface LoanWhitelistRow {
        Id?: number;
        Msisdn?: string;
    }

    export namespace LoanWhitelistRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Msisdn';
        export const localTextPrefix = 'LoanWhitelist.LoanWhitelist';
        export const deletePermission = 'LoanWhitelist:Manage';
        export const insertPermission = 'LoanWhitelist:Manage';
        export const readPermission = 'LoanWhitelist:Manage';
        export const updatePermission = 'LoanWhitelist:Manage';

        export declare const enum Fields {
            Id = "Id",
            Msisdn = "Msisdn"
        }
    }
}
